
export class UnknownDocumentCategoryCodeError extends Error {
    constructor(public readonly unknownCategoryCode: string) {
        super(`Field7 parse error - could not map document category code [${unknownCategoryCode}] to its definition`);
        this.name = UnknownDocumentCategoryCodeError.name;
    }
}